import { UPLOAD_DOCUMENT } from "../actions";
import { LOADING } from "../../global/actions";

// TODO GLOBAL
const initialState = {
  parameters: {
    materials: {},
    contracts: {},
    orders: {},
    placeholderMaterials: {},
    serialNumbers: {},
    systems: {},
    systemApplications: {},
    licenses: {},
    dataQualitySapOrders: {},
    hwsSnsTrail: {},
    apiResponse: {},
    bulkReports: {},
    missingSnsStatus: {},
  },
};

function fileReducer(state = initialState, action) {
  if (action?.type !== "SET_USER_SESSION") {
    console.log("reducer action", action);
  }
  switch (action.type) {
    case LOADING:
      break;
    default:
      state.loading = false;
      break;
  }
  if (state.errors) {
    delete state.errors;
  }
  state.errors = action.errors;
  switch (action.type) {
    case UPLOAD_DOCUMENT:
      if (action.errors) {
        state = Object.assign({}, state, {
          apiResponse: { message: action.errors, source: "UPLOAD_FILES" },
        });
        return state;
      }
      state = Object.assign({}, state, {
        apiResponse: { message: action.result, source: "UPLOAD_FILES" },
      });
      return state;
    default:
      return state;
  }
  return state;
}

export default fileReducer;
